export enum Level {
  Success,
  Info,
  Warn,
  Error,
}

export class Notification {

  private static counter = 0;

  public Id: string;
  public Order: number;
  public Level: Level;
  public Message: string;
  public Title?: string;
  public Details: string[];
  public Error: any;
  public Acknowledged: boolean = false;
  public Date: Date;

  public Dismissed: boolean = false;

  constructor(
    message: string,
    level: Level = Level.Info,
    title?: string,
    details: string[] = [],
    error: any = null,
  ) {
    this.Order = Notification.counter++;
    this.Id = `${this.Order}`;
    this.Message = message;
    this.Level = level;
    this.Title = title;
    this.Message = message;
    this.Details = details;
    this.Error = error;
    this.Date = new Date(Date.now());
  }

  public Ack() {
    this.Acknowledged = true;
  }

  public Dismiss() {
    this.Dismissed = true;
  }
}
